import type { AnnotationShape } from '../types';
import { exportSvg } from './svgExport';

/**
 * Rasterizes an SVG string into a canvas element.
 * Creates an Image from the SVG, draws it onto a canvas at the given dimensions.
 */
export function rasterizeSvg(svgString: string, width: number, height: number): Promise<HTMLCanvasElement> {
  return new Promise((resolve, reject) => {
    const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(url);
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Failed to get canvas 2d context'));
        return;
      }
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas);
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to load SVG image'));
    };

    img.src = url;
  });
}

/**
 * Rasterizes annotation shapes into a canvas element.
 * Converts shapes to SVG via exportSvg, then rasterizes.
 */
export function rasterizeAnnotation(
  shapes: AnnotationShape[],
  width: number,
  height: number,
): Promise<HTMLCanvasElement> {
  const svgString = exportSvg(shapes, width, height);
  return rasterizeSvg(svgString, width, height);
}
